export default "__VITE_ASSET__DWjssBQr__"